module.exports = __webpack_public_path__ + "b3ec11520e8835e338ccec02eb5c1722.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-14.png
// module id = 3241
// module chunks = 0